import {
  serviceSequenceList,
  serviceSequenceDetail,
} from "../services/Sequence.service";

export const SEQUENCE_LIST_INIT = "SEQUENCE_LIST_INIT";
export const SEQUENCE_LIST_FETCHED = "SEQUENCE_LIST_FETCHED";
export const SEQUENCE_LIST_FAIL = "SEQUENCE_LIST_FAIL";
export const SEQUENCE_DETAIL_SET = "SEQUENCE_DETAIL_SET";
export const SEQUENCE_DETAIL_CLEAR = "SEQUENCE_DETAIL_CLEAR";

export function actionFetchSequenceList(params = {}) {
  return (dispatch) => {
    dispatch({ type: SEQUENCE_LIST_INIT });
    return serviceSequenceList(params).then((data) => {
      if (!data.error) {
        dispatch({
          type: SEQUENCE_LIST_FETCHED,
          payload: data.data || {},
        });
      } else {
        dispatch({ type: SEQUENCE_LIST_FAIL, payload: data.message });
      }
      return data;
    });
  };
}

export function actionFetchSequenceDetail(id) {
  return (dispatch) => {
    return serviceSequenceDetail({ id }).then((data) => {
      if (!data.error && data.data) {
        dispatch({ type: SEQUENCE_DETAIL_SET, payload: data.data });
      }
      return data;
    });
  };
}

export function actionClearSequenceDetail() {
  return { type: SEQUENCE_DETAIL_CLEAR };
}
